import React from 'react';
import { StarIcon } from 'lucide-react';
export type Testimonial = {
  quote: string;
  author: string;
  /** City, or city + wedding month. */
  role?: string;
  /** FTC disclosure, e.g. "Early reader — received a free copy." */
  disclosure?: string;
};
type TestimonialsProps = {
  testimonials: Testimonial[];
  title?: string;
  background?: 'ivory' | 'white';
};
export function Testimonials({
  testimonials,
  title,
  background = 'white'
}: TestimonialsProps) {
  // Never render empty or invented proof.
  if (testimonials.length === 0) return null;
  return <section aria-label={title ?? 'Testimonials'} className={`w-full ${background === 'ivory' ? 'bg-ivory' : 'bg-white'}`} data-id="element-200" data-mp="3229024en8h3l">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-201" data-mp="2s2i1nrmyphy8">
        {title && <h2 className="font-serif font-normal text-ink text-[28px] sm:text-[38px] text-center" data-id="element-202" data-mp="v9ooxkq6li2z">
            {title}
          </h2>}
        <ul className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-203" data-mp="qb4zhacdpo5v">
          {testimonials.map(t => <li key={t.quote} className="flex flex-col rounded border border-sage/20 bg-sand p-6" data-id="element-204" data-mp="h8181pbqwil0">
              <div className="flex items-center gap-0.5" aria-label="5 out of 5 stars" data-id="element-205" data-mp="78aepqyx89mi">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 fill-sage text-sage" aria-hidden="true" data-id="element-206" data-mp="c7dfgz7vbtoo" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 flex-grow font-serif text-ink text-[17px] leading-relaxed" data-id="element-207" data-mp="14xlpu4w5x9sp">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <footer className="mt-auto pt-5 text-xs text-ink-muted" data-id="element-208" data-mp="v4enkswpy9wu">
                <span className="block font-sans font-semibold text-ink text-[13px]" data-id="element-209" data-mp="1ius71v18n0ft">
                  {t.author}
                </span>
                {t.role && <span className="block mt-0.5" data-id="element-210" data-mp="1nnblsvbnw1m7">{t.role}</span>}
                {t.disclosure && <span className="block mt-1.5 italic" data-id="element-211" data-mp="1xh7msr11g2oy">{t.disclosure}</span>}
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}